import { defineStore } from "pinia";
import { useGetData } from "~/composables/useGetData";
import { usePostData } from "~/composables/usePostData";
import { usePostDataFileStream } from "~/composables/usePostDataFileStream";

export const useOrdiniAcquistoStore = defineStore("ordiniAcquistoStore", {
  state: () => ({
    ordiniAcquisto: [],
    ordiniAcquistoSelezionato: {},
    caricandoOrdiniAcquisto: false,
    errorMessage: null,
    fromDate: null,
    toDate: null,
    filtroCompanyId: null,
    filtraSpedito: null,
    filtraPresoInCarico: null,
    filtri: null
  }),
  getters: {
    isOrdiniAcquistoSelezionato (state) {
      if (
        !state.ordiniAcquistoSelezionato ||
        Object.keys(state.ordiniAcquistoSelezionato).length === 0
      ) {
        return false;
      } else {
        return true;
      }
    }
  },
  actions: {
    async getOrdiniAcquistoOdoo () {
      this.caricandoOrdiniAcquisto = true;
      const { data, getData, loading, messageError } = useGetData();
      await getData("/api/ordini_acquisto");
      if (!messageError.value) {
        if (this.ordiniAcquisto.length === 0) {
          this.ordiniAcquisto = data.value;
        } else {
          for (const ordine of data.value) {
            this.aggiornareElemento(ordine);
          }
        }

        this.caricandoOrdiniAcquisto = loading.value;
      } else {
        this.errorMessage = messageError;
        this.caricandoOrdiniAcquisto = false;
      }
    },
    async getOrdiniAcquistoDaPrendereCaricoOdoo () {
      this.caricandoOrdiniAcquisto = true;
      const { data, getData, loading, messageError } = useGetData();
      await getData("/api/ordini_acquisto/prendere_in_carico");
      if (!messageError.value) {
        if (this.ordiniAcquisto.length === 0) {
          this.ordiniAcquisto = data.value;
        } else {
          for (const ordine of data.value) {
            this.aggiornareElemento(ordine);
          }
        }
        this.caricandoOrdiniAcquisto = false;
      } else {
        this.errorMessage = messageError;
        this.caricandoOrdiniAcquisto = false;
      }
    },
    async aggiornaStato (ordine) {
      // aggiorna lo stato dell'ordine acquisto. dentro il body dell'ordine c'è inserito che stato sta aggiornando
      // esempio: { id: item.id, action_url: "cambia_in_carico"}
      const { data, postData, loading, messageError } = usePostData();
      await postData("/api/ordini_acquisto/aggiorna_stato", ordine);
      if (!messageError.value) {
        this.aggiornareElemento(data.value.ordini);
        this.caricandoOrdiniAcquisto = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    },
    async aggiornaStatoMassa (body) {
      const {
        data,
        postData,
        messageError
      } = usePostData();
      await postData(
        "/api/ordini_acquisto/aggiorna_stato_spedito_movimento_massa",
        body
      );
      if (!messageError.value) {
        this.aggiornareElementoMassa(data.value.ordini);
        this.caricandoOrdiniAcquisto = false;
      } else {
        this.errorMessage = messageError;
      }
    },
    aggiornareElemento (data) {
      const index = this.ordiniAcquisto.findIndex(({ id }) => id === data.id);

      if (index < 0) {
        this.ordiniAcquisto.push(data);
      } else {
        Object.assign(this.ordiniAcquisto[index], data);
      }
    },
    aggiornareElementoMassa (data) {
      for (const ordine of data) {
        const index = this.ordiniAcquisto.findIndex(
          ({ id }) => id === ordine.id
        );
        Object.assign(this.ordiniAcquisto[index], ordine);
      }
    },
    resetOrdiniAcquistoSelezionato () {
      this.ordiniAcquistoSelezionato = [];
    },
    async stampaOrdiniAcquisto (body) {
      const { data, postDataStream } = usePostDataFileStream();
      await postDataStream("/api/ordini_acquisto/stampa_ordini_acquisto", body);
      return data.value;
    },
    async excelOrdiniAcquisto (body) {
      const { data, postDataStream } = usePostDataFileStream();
      await postDataStream("/api/ordini_acquisto/excel_ordini_acquisto", body);
      return data.value;
    },
    async searchOrdiniAcquistoFiltrati (filtri: Array<Object>) {
      this.caricandoOrdiniAcquisto = true;
      const { data, postData, loading, messageError } = usePostData();
      await postData("/api/ordini_acquisto/cerca_ordini_acquisto", filtri);
      if (!messageError.value) {
        this.ordiniAcquisto = data.value.result;
        this.caricandoOrdiniAcquisto = loading.value;
      } else {
        this.errorMessage = messageError;
      }
    },
    async downloadOrdiniAcquistoXml ({ order_id }) {
      const { data, postDataStream } = usePostDataFileStream();
      console.log("pre call api");
      await postDataStream("/api/ordini_acquisto/generate_po_xml", { order_id });
      console.log("post call api");
      console.log("dati>", data.value);
      return data.value;
    },
    async uploadFileOdoo (body) {
      const { data, postData, messageError } = usePostData();
      await postData("/api/ordini_acquisto/upload_file", body);
      if (!messageError.value) {
        this.getOrdiniAcquistoOdoo();
        return data.value;
      } else {
        this.errorMessage = messageError;
      }
    },
    async aggiornaDatiSpedizionePOT(payload) {
      const { data, postData, messageError } = usePostData();

      try {
        await postData("/api/ordini_acquisto/aggiorna_spedizione_pot", payload);

        const responseData = data.value;

        if (responseData && responseData.success) {
          const ordineAggiornato = responseData.ordini;

          this.aggiornareElemento(ordineAggiornato);

          return ordineAggiornato;
        } else {
          const errorMsg = responseData.error || "Risposta non valida dal server.";
          this.errorMessage = errorMsg;
          throw new Error(errorMsg);
        }
      } catch (error) {
        this.errorMessage = messageError.value || error.message;

        throw error;
      }
    },
    async aggiornaDatiSpedizionePOTMassa(payload) {
      const { data, postData, messageError } = usePostData();

      try {
        await postData("/api/ordini_acquisto/aggiorna_spedizione_pot_massa", payload);

        const responseData = data.value;

        if (responseData && responseData.success) {
          const ordiniAggiornati = responseData.ordini;

          this.aggiornareElementoMassa(ordiniAggiornati);

          return ordiniAggiornati;
        } else {
          const errorMsg = responseData.error || "Risposta non valida dal server.";
          this.errorMessage = errorMsg;
          throw new Error(errorMsg);
        }
      } catch (error) {
        this.errorMessage = messageError.value || error.message;
        throw error;
      }
    },
    async annullaSpedizionePOT(payload) {
      const { data, postData, messageError } = usePostData();
      try {
        await postData("/api/ordini_acquisto/annulla_spedizione_pot", payload);
        if (data.value && data.value.success) {
          this.aggiornareElemento(data.value.ordini);
        } else {
          this.errorMessage = data.value.error || "Errore durante l'annullamento della spedizione POT.";
        }
      } catch (error) {
        this.errorMessage = messageError.value || error.message;
        throw error;
      }
    },
    async annullaSpedizionePOTMassa(payload) {
      const { data, postData, messageError } = usePostData();
      try {
        await postData("/api/ordini_acquisto/annulla_spedizione_pot_massa", payload);
        if (data.value && data.value.success) {
          this.aggiornareElementoMassa(data.value.ordini);
        } else {
          this.errorMessage = data.value.error || "Errore durante l'annullamento massivo della spedizione POT.";
        }
      } catch (error) {
        this.errorMessage = messageError.value || error.message;
        throw error;
      }
    }
  }
});
